import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPickedDate } from 'redux/actions'
import Legend from './Legend';
import { TimelineSubHeaderContainer } from '../../styles';
import {
  DoubleLeftDateIcon,
  DoubleRightDateIcon,
} from 'assets/icons';
import DatePicker from 'components/DatePicker';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';
import colors from 'constants/colors';

const SubHeader = ({ timelineState }) => {
  
  const pickedDate = useSelector(state => state.pickedDateReducer.pickedDate)
  const dispatch = useDispatch() 

  const { state, setState } = timelineState;
  const onPreWeekClick = () => {
    dispatch(setPickedDate(moment(pickedDate).tz(TIME_ZONE).subtract(7, 'day')).valueOf())
    setState({
      visibleTimeStart: moment(state.visibleTimeStart).tz(TIME_ZONE).subtract(7, 'day').valueOf(),
      visibleTimeEnd: moment(state.visibleTimeEnd).tz(TIME_ZONE).subtract(7, 'day').valueOf(),
      today: moment(state.today).tz(TIME_ZONE).subtract(7, 'day').valueOf(),
      endToday: moment(state.endToday).tz(TIME_ZONE).subtract(7, 'day').valueOf(),
    });
  };

  const onNextWeekClick = () => {
    dispatch(setPickedDate(moment(pickedDate).tz(TIME_ZONE).add(7, 'day').valueOf()))
    setState({
      visibleTimeStart: moment(state.visibleTimeStart).tz(TIME_ZONE).add(7, 'day').valueOf(),
      visibleTimeEnd: moment(state.visibleTimeEnd).tz(TIME_ZONE).add(7, 'day').valueOf(),
      today: moment(state.today).tz(TIME_ZONE).add(7, 'day').valueOf(),
      endToday: moment(state.endToday).tz(TIME_ZONE).add(7, 'day').valueOf(),
    });
  };

  return (
    <TimelineSubHeaderContainer>
      <div className="contentContainer">
        <div className="dateSection">
          <DoubleLeftDateIcon
            onClick={onPreWeekClick}
            style={{ cursor: 'pointer' }}
          />
          <div className="datePickerContainer">
            <DatePicker
              dateValue={moment(pickedDate).tz(TIME_ZONE)}
              setDate={(date)=>{
                dispatch(setPickedDate(moment(date).tz(TIME_ZONE).valueOf()))
              }}
              timelineState={timelineState}
              variant="standard"
              additionalstyle={`
                width: 137px;

                input{
                  padding-right: 26px;
                  border-bottom: 2px solid ${colors.grey1};
                }

                .MuiInput-root {
                  margin-top: 0;
                }
              `}
            />
          </div>
          <DoubleRightDateIcon
            onClick={onNextWeekClick}
            style={{ cursor: 'pointer' }}
          />
        </div>
        <Legend />
      </div>
    </TimelineSubHeaderContainer>
  );
};

export default SubHeader;
